import React, { useEffect, useState } from "react";
import axios from "axios";
import { Coins } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => `€ ${Number(v || 0).toFixed(2)}`;
const LABEL = { earn: "Accredito", use: "Utilizzo", expire: "Scaduto", adjust: "Rettifica" };

// Portale cliente: saldo cashback, progresso verso la soglia e ultimi movimenti
export default function CashbackCard({ card, sessionToken, refreshKey }) {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    axios.post(`${API}/public/cashback`, { card_number: card, session_token: sessionToken }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [card, sessionToken, refreshKey]);
  if (!d || !d.enabled) return null;
  const pct = d.use_threshold > 0 ? Math.min(100, Math.round((d.balance / d.use_threshold) * 100)) : 100;
  return (
    <div className="card-elev p-4 space-y-2" data-testid="portal-cashback-card">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 font-heading font-bold"><Coins className="h-5 w-5 text-emerald-300" /> Il tuo cashback</div>
        <div className="text-2xl font-extrabold text-emerald-300" data-testid="portal-cashback-balance">{eur(d.balance)}</div>
      </div>
      <div className="text-xs text-zinc-400">Ogni acquisto{d.min_spend > 0 ? ` da ${eur(d.min_spend)}` : ""} ti accredita il <b className="text-zinc-200">{d.percent}%</b> in credito{d.also_points ? ", in più ai punti" : ""}. {d.expiry_months ? `Il credito vale ${d.expiry_months} mesi.` : ""}</div>
      {d.usable ? (
        <div className="rounded-lg bg-emerald-500/10 border border-emerald-500/30 p-2 text-xs text-emerald-200" data-testid="portal-cashback-usable">Credito utilizzabile: chiedi in cassa di scalarlo dal conto{d.use_online ? " oppure usalo nel tuo ordine online" : ""}.</div>
      ) : (
        <div data-testid="portal-cashback-progress">
          <div className="h-2 rounded-full bg-zinc-800 overflow-hidden"><div className="h-full bg-emerald-400 transition-[width]" style={{ width: `${pct}%` }} /></div>
          <div className="text-xs text-zinc-400 mt-1">Ti mancano <b className="text-zinc-200">{eur(d.missing_to_threshold)}</b> per poter usare il credito (soglia {eur(d.use_threshold)})</div>
        </div>
      )}
      {d.ledger?.length > 0 && (
        <div>
          <button type="button" onClick={() => setOpen((o) => !o)} className="text-xs text-sky-300 hover:underline" data-testid="portal-cashback-toggle">{open ? "Nascondi movimenti" : `Movimenti (${d.ledger.length})`}</button>
          {open && <ul className="mt-1 divide-y divide-zinc-800 text-xs" data-testid="portal-cashback-ledger">{d.ledger.map((r) => { const plus = r.type === "earn" || (r.type === "adjust" && r.amount > 0); return <li key={r.id} className="py-1 flex justify-between gap-2"><span className="text-zinc-400">{r.created_at.slice(0, 10)} · {LABEL[r.type] || r.type}{r.note ? ` · ${r.note}` : ""}</span><span className={plus ? "text-emerald-300" : "text-red-300"}>{plus ? "+" : "−"}{eur(Math.abs(r.amount))}</span></li>; })}</ul>}
        </div>
      )}
    </div>
  );
}
